import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';

class LoginPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state = {
            email : '' , 
            password : '' , 
            isRememberme : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();

        const { dispatch } = this.props;

        dispatch(userActions.login(this.state));
    }

    render(){
        let {email,password,isRememberme} = this.state; 
        const {loading} = this.props;

        return (
            <div>
                <div className="columns">
                    <div className="column is-6">
                        <h3 className="title">Sign In</h3>
                    </div>
                    <div className="column is-6 has-text-right">
                        Need an account? <Link to="/register">Register</Link>
                    </div>
                </div>
                
                <form onSubmit={this.handleSubmit}>
                    <div className="field">
                        <div className="control m-t-lg">
                            <div className="level is-mobile">
                                <div className="level-left control-label">Email Address  </div>
                                <div className="level-right has-text-right">
                                    <Link to="/resendemail">Resend Email Verification</Link>
                                </div>
                            </div>
                            <input className="input" type="email" name="email" value={email} onChange={this.handleChange} placeholder="" />
                        </div>
                        <div className="control m-t-lg">
                            <div className="level is-mobile">
                                <div className="level-left control-label">Password  </div>
                                <div className="level-right has-text-right">
                                    <Link to="/forgetpassword">Forgot your password ?</Link>
                                </div>
                            </div>
                            <input className="input" type="password" name="password" value={password} onChange={this.handleChange} placeholder="" />
                        </div>
                        <div className="control m-t-lg">
                            <input type="checkbox" value={isRememberme} onChange={this.handleChange}/>
                            <span className="m-l-xs">Remember My Email Address</span>
                        </div>
                       
                        <div className="control m-t-lg">
                            <input type="submit" value="Login" className="button button-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading } = state;
    return {
        loading 
    };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage }; 



// WEBPACK FOOTER //
// ./src/Views/LoginPage/LoginPage.jsx